import React, { useState } from "react"
import { useIntl } from "react-intl"
import { Checkbox as CheckboxLD } from "@walmart-web/livingdesign-components"
import {
	Title,
	Loading,
	Disabled,
} from "components/Shared/Filters/Select/components"
import { addAllOption } from "components/Shared/GlobalFilter/utils"
import { Tuple } from "components/Shared/Interfaces"
import {
	capitalizeTuple,
	optionsSelected,
} from "components/Shared/Filters/utils"
import "./index.scss"

interface CheckboxProps {
	id: string
	options: Array<Tuple>
	isLoading?: boolean
	isDisabled?: boolean
	defaultValue?: Array<Tuple>
	disabledText?: string
	hasTitle?: boolean
	onChange: (value: Array<Tuple>) => void
	allOption?: boolean
}

const Checkbox: React.FC<CheckboxProps> = ({
	id,
	options,
	isLoading,
	isDisabled,
	defaultValue = [],
	disabledText,
	allOption,
	onChange,
	hasTitle = true,
}) => {
	const capitalizedOptions = capitalizeTuple(options)
	const capitalizedDefaultValue = capitalizeTuple(defaultValue)
	const optionsWithAll = addAllOption(capitalizedOptions)
	const allOptions = allOption ? optionsWithAll : capitalizedOptions
	const [selectedValues, setSelectedValues] = useState<Array<Tuple>>(
		capitalizedDefaultValue
	)
	const intl = useIntl()
	const title = `phronesis.filters.${id}`
	const disabledId = `phronesis.filters.${disabledText}`

	const selectOnChange = (value: Tuple) => {
		const opt = optionsSelected(value, selectedValues, allOptions, allOption)
		setSelectedValues(opt)
		onChange(opt)
	}

	const renderCheckbox = () => {
		if (isDisabled) {
			return <Disabled intl={intl} title={disabledId} />
		} else if (isLoading) {
			return <Loading intl={intl} title={title} />
		}
		return (
			<div className="filters-checkbox-list">
				{allOptions.map((option) => (
					<CheckboxLD
						key={option.code}
						label={option.name}
						checked={selectedValues.some((item) => item.code === option.code)}
						onChange={() => selectOnChange(option)}
					/>
				))}
			</div>
		)
	}

	const CheckboxTitle: React.FC = () => {
		return hasTitle ? (
			<Title
				title={intl.formatMessage({ id: title })}
				isDisabled={isDisabled}
			/>
		) : (
			<React.Fragment />
		)
	}

	return (
		<div className="filters-checkbox">
			<CheckboxTitle />
			{renderCheckbox()}
		</div>
	)
}

export default Checkbox
